import gql from "graphql-tag";

export const GET_PAGINATED_NOTIFICATIONS = gql`
  query getPaginatedNotifications($UISorting: UISortingNotifications!) {
    getPaginatedNotifications(UISorting: $UISorting) {
      notifications {
        caseNumber
        isActive
        notificationDate
        notificationId
        notificationMessage
        visaType
        empBusinessName
        jobTitle
        formId
        partitionKey
      }
      total_count
    }
  }
`;

export const GET_PAGINATED_NOTIFICATIONS_COUNT = gql`
  query getNotificationsCount {
    getNotificationsCount {
      Active
      Archived
    }
  }
`;

export const ARCHIVE_NOTIFICATIONS = gql`
  mutation archiveNotifications($Notifications: [NotificationInput!]!) {
    archiveNotifications(Notifications: $Notifications)
  }
`;
